type Props = {
  logoUrl: string | null | undefined;
  /** Alt text — defaults to empty string (decorative logo) */
  alt?: string;
};

/**
 * Renders the tenant logo when a URL is provided; renders nothing otherwise.
 * Security: loaded via <img> only (no CSS url() / innerHTML injection).
 */
export function TenantLogo({ logoUrl, alt = '' }: Props) {
  if (!logoUrl) return null;
  return (
    <div className="mb-6 flex items-center">
      <img
        src={logoUrl}
        alt={alt}
        className="max-h-12 max-w-[160px] object-contain"
        crossOrigin="anonymous"
        referrerPolicy="no-referrer"
      />
    </div>
  );
}
